import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importIntegrations = () => import(/* webpackChunkName: "integrations" */ './containers/IntegrationsContainer');

const IntegrationsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importIntegrations}
      path={match.url}
    />
  </LoginRequiredContainer>
);

IntegrationsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default IntegrationsRoutes;
